export default __webpack_public_path__ + "static/media/cn.c9e96436.svg";